export default "__VITE_ASSET__CnxQMzaJ__"